
export default function Searchbar({setQuery}) {
  return (
    <>
        <div className="search-container" onChange={(e) => setQuery(e.target.value.toLowerCase())}>
          <i className="fa-solid fa-magnifying-glass"></i>
          <input type="text" placeholder="Search for a country..."/>
        </div>
    </>
  )
}
